export default "__VITE_ASSET__BW6o7oWT__"